/**
 * DIFFY — Story Stats
 * Contagem animada disparada ao entrar em viewport.
 * Reengata em recargas AJAX do Horizon via MutationObserver.
 */
(function () {
  'use strict';

  var initedGrids = new WeakSet();

  function formatNumber(value, isInt) {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: isInt ? 0 : 1,
      maximumFractionDigits: isInt ? 0 : 1
    }).format(value);
  }

  function renderFinalValue(el) {
    var target = Number(el.dataset.target) || 0;
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var isInt = Number.isInteger(target);

    el.textContent = prefix + formatNumber(target, isInt) + suffix;
  }

  function animateCount(el, duration) {
    var target = Number(el.dataset.target) || 0;
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var start = null;
    var isInt = Number.isInteger(target);

    function step(ts) {
      if (!start) start = ts;

      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = target * eased;
      var displayedValue = isInt ? Math.round(current) : Number(current.toFixed(1));

      el.textContent = prefix + formatNumber(displayedValue, isInt) + suffix;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        renderFinalValue(el);
      }
    }

    window.requestAnimationFrame(step);
  }

  function initGrid(grid) {
    if (initedGrids.has(grid) || !grid) return;
    initedGrids.add(grid);

    var numbers = grid.querySelectorAll('[data-diffy-count]');
    if (!numbers.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            numbers.forEach(function (el) {
              if (reduceMotion) {
                renderFinalValue(el);
              } else {
                animateCount(el, 1200);
              }
            });

            observer.unobserve(grid);
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(grid);
  }

  function scanForGrids(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var grids = scope.querySelectorAll('[data-diffy-stats]');
    grids.forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanForGrids(document);
    });
  } else {
    scanForGrids(document);
  }

  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches('[data-diffy-stats]')) {
          initGrid(node);
        }

        if (node.querySelectorAll) {
          scanForGrids(node);
        }
      });
    });
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (evt) {
    scanForGrids(evt.target);
  });
})();
